<template>
    <div class="content">
        <table class="data-table">
            <thead>
                <tr>
                    <th>时间</th>
                    <th>姓名</th>
                    <th>电话</th>
                </tr>
            </thead>
            <tbody v-if="clients_data.items">
                <tr v-for="(item, i) in clients_data.items" :key="i">
                    <td>{{ item.created_time }}</td>
                    <td>{{ item.name || '-' }}</td>
                    <td>{{ item.phone }}</td>
                </tr>
            </tbody>
        </table>
        <paginator :page="page" :total_count="clients_data.total_count" @changePage="changePage"></paginator>
    </div>
</template>
<script>
import Paginator from '@/components/paginator'
import ProgressChart from './_progress_chart'
export default {
    components: {
        Paginator,
        ProgressChart
    },
    methods: {
        changePage (page) {
            this.$emit('changePage', page)
        }
    },
    props: {
        clients_data: {
            type: Object,
            default: () => ({})
        },
        page: {
            type: Number,
            default: 1
        }
    }
}
</script>
<style lang="scss" scoped>
.content {
    background-color: #fff;
    padding-bottom: 30px;
}
</style>
